import { apiClient } from "shared/utils";
import { GetLinksConfigResponse } from "api/models";

export const getLinksConfig = async (shopId: number) => {
  const { data } = await apiClient.get<GetLinksConfigResponse>(`${shopId}/links`);

  return data;
};
